import React, { useEffect } from "react";
import {
    Box,
    Typography,
    Grid,
    Button,
} from "@mui/material";
import contactusimage from "../assets/contactus/contactusinfiimage.png";
import { useMediaQueries } from "../usecontext/UseProvider";
import { FaSquareFacebook } from "react-icons/fa6";
import { TfiLocationPin } from "react-icons/tfi";
import { FiPhoneCall } from "react-icons/fi";
import { GoMail } from "react-icons/go";
import Header from "../adminComponents/header/Header";
import { getContactUS } from "../services/ConatactUs";
import { useNavigate } from "react-router-dom";

const ContactUSPage = () => {
    const { isSmallScreen, setLoading, contactUSData, setContactUSData } = useMediaQueries();
    const navigate = useNavigate();

    const getContactUSData = async () => {
        try {
            setLoading(true);
            const response = await getContactUS();
            setContactUSData(response?.contactUsData);
            setLoading(false);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getContactUSData();
    }, []);

    const handleOnEdit = () => {
        navigate('/admin/contact/edit')
    };

    return (
        <>
            <Header title="Contact" />
            <Box sx={{ pt: 3 }}>
                <Grid container spacing={4} alignItems="center">
                    {/* Right Section - Content */}
                    <Grid item xs={12} md={6}>
                        <Typography
                            variant={isSmallScreen ? 'h5' : 'h4'}
                            sx={{ fontWeight: "bold", marginBottom: 3 }}
                        >
                            Our Contact Information
                        </Typography>
                        <Typography
                            variant={"body2"}
                            sx={{
                                fontSize: { lg: '20px', md: '18px', xs: '16px' },
                            }}
                        >
                            Always there for you when you need us
                        </Typography>

                        <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <Box sx={{ display: "flex", gap: 1.5 }}>
                                <TfiLocationPin style={{ color: '#01A0E2', fontSize: '20px' }} />
                                <Typography variant="body2">
                                    {contactUSData?.address?.split(",").map((part, index) => (
                                        <React.Fragment key={index}>
                                            {index === 2 && <br />}
                                            {part}
                                            {index < contactUSData?.address?.split(",").length - 1 && ", "}
                                        </React.Fragment>
                                    ))}
                                </Typography>
                            </Box>
                            <Box sx={{ display: "flex", gap: 1.5 }}>
                                <FiPhoneCall style={{ color: '#01A0E2', fontSize: '20px' }} />
                                <Typography variant="body2">
                                    {contactUSData?.mobileNumber}
                                </Typography>
                            </Box>
                            <Box sx={{ display: "flex", gap: 1.5 }}>
                                <GoMail style={{ color: '#01A0E2', fontSize: '20px' }} />
                                <Typography variant="body2">
                                    {contactUSData?.email}
                                </Typography>
                            </Box>
                        </Box>
                        <Typography
                            variant={"body2"}
                            sx={{
                                fontSize: { lg: '20px', md: '18px', xs: '16px' },
                                mt: 2,
                            }}
                        >
                            Follow our social media
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 1, mt: 2 }} >
                            <Box
                                onClick={() => window.open(`${contactUSData?.instagramLink}`)}
                                sx={{ cursor: 'pointer' }}
                            >
                                <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M24.6218 2.41064H8.70812C5.41228 2.41064 2.74048 5.08245 2.74048 8.37828V24.292C2.74048 27.5878 5.41228 30.2596 8.70812 30.2596H24.6218C27.9177 30.2596 30.5895 27.5878 30.5895 24.292V8.37828C30.5895 5.08245 27.9177 2.41064 24.6218 2.41064Z" fill="url(#paint0_radial_61_9041)" />
                                    <path d="M24.6218 2.41064H8.70812C5.41228 2.41064 2.74048 5.08245 2.74048 8.37828V24.292C2.74048 27.5878 5.41228 30.2596 8.70812 30.2596H24.6218C27.9177 30.2596 30.5895 27.5878 30.5895 24.292V8.37828C30.5895 5.08245 27.9177 2.41064 24.6218 2.41064Z" fill="url(#paint1_radial_61_9041)" />
                                    <path d="M24.6218 2.41064H8.70812C5.41228 2.41064 2.74048 5.08245 2.74048 8.37828V24.292C2.74048 27.5878 5.41228 30.2596 8.70812 30.2596H24.6218C27.9177 30.2596 30.5895 27.5878 30.5895 24.292V8.37828C30.5895 5.08245 27.9177 2.41064 24.6218 2.41064Z" fill="url(#paint2_radial_61_9041)" />
                                    <path d="M23.6272 10.865C23.6272 11.6889 22.9592 12.3569 22.1353 12.3569C21.3114 12.3569 20.6434 11.6889 20.6434 10.865C20.6434 10.041 21.3114 9.37305 22.1353 9.37305C22.9592 9.37305 23.6272 10.041 23.6272 10.865Z" fill="white" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M16.665 21.3079C19.4115 21.3079 21.638 19.0814 21.638 16.3348C21.638 13.5883 19.4115 11.3618 16.665 11.3618C13.9185 11.3618 11.6919 13.5883 11.6919 16.3348C11.6919 19.0814 13.9185 21.3079 16.665 21.3079ZM16.665 19.3187C18.3129 19.3187 19.6488 17.9828 19.6488 16.3348C19.6488 14.6869 18.3129 13.351 16.665 13.351C15.017 13.351 13.6812 14.6869 13.6812 16.3348C13.6812 17.9828 15.017 19.3187 16.665 19.3187Z" fill="white" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M6.7189 15.9374C6.7189 12.5952 6.7189 10.9241 7.36934 9.64755C7.94147 8.52466 8.8544 7.61173 9.97729 7.03959C11.2538 6.38916 12.9249 6.38916 16.2671 6.38916H17.0628C20.405 6.38916 22.0761 6.38916 23.3526 7.03959C24.4755 7.61173 25.3885 8.52466 25.9606 9.64755C26.611 10.9241 26.611 12.5952 26.611 15.9374V16.7331C26.611 20.0752 26.611 21.7464 25.9606 23.0229C25.3885 24.1458 24.4755 25.0587 23.3526 25.6308C22.0761 26.2813 20.405 26.2813 17.0628 26.2813H16.2671C12.9249 26.2813 11.2538 26.2813 9.97729 25.6308C8.8544 25.0587 7.94147 24.1458 7.36934 23.0229C6.7189 21.7464 6.7189 20.0752 6.7189 16.7331V15.9374ZM16.2671 8.37837H17.0628C18.7668 8.37837 19.925 8.37992 20.8203 8.45307C21.6925 8.52432 22.1385 8.65347 22.4496 8.81199C23.1981 9.19342 23.8067 9.80204 24.1882 10.5506C24.3467 10.8617 24.4759 11.3077 24.5471 12.1799C24.6202 13.0752 24.6218 14.2334 24.6218 15.9374V16.7331C24.6218 18.437 24.6202 19.5952 24.5471 20.4906C24.4759 21.3628 24.3467 21.8087 24.1882 22.1199C23.8067 22.8684 23.1981 23.477 22.4496 23.8584C22.1385 24.017 21.6925 24.1462 20.8203 24.2174C19.925 24.2905 18.7668 24.2921 17.0628 24.2921H16.2671C14.5632 24.2921 13.4049 24.2905 12.5096 24.2174C11.6374 24.1462 11.1914 24.017 10.8803 23.8584C10.1318 23.477 9.52317 22.8684 9.14173 22.1199C8.98321 21.8087 8.85406 21.3628 8.78281 20.4906C8.70967 19.5952 8.70812 18.437 8.70812 16.7331V15.9374C8.70812 14.2334 8.70967 13.0752 8.78281 12.1799C8.85406 11.3077 8.98321 10.8617 9.14173 10.5506C9.52317 9.80204 10.1318 9.19342 10.8803 8.81199C11.1914 8.65347 11.6374 8.52432 12.5096 8.45307C13.4049 8.37992 14.5632 8.37837 16.2671 8.37837Z" fill="white" />
                                    <defs>
                                        <radialGradient id="paint0_radial_61_9041" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(12.6865 23.2974) rotate(-55.3758) scale(25.382)">
                                            <stop stopColor="#B13589" />
                                            <stop offset="0.79309" stopColor="#C62F94" />
                                            <stop offset="1" stopColor="#8A3AC8" />
                                        </radialGradient>
                                        <radialGradient id="paint1_radial_61_9041" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(11.6919 31.2542) rotate(-65.1363) scale(22.4723)">
                                            <stop stopColor="#E0E8B7" />
                                            <stop offset="0.444662" stopColor="#FB8A2E" />
                                            <stop offset="0.71474" stopColor="#E2425C" />
                                            <stop offset="1" stopColor="#E2425C" stopOpacity="0" />
                                        </radialGradient>
                                        <radialGradient id="paint2_radial_61_9041" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(1.24857 3.40525) rotate(-8.1301) scale(38.6811 8.2735)">
                                            <stop offset="0.156701" stopColor="#406ADC" />
                                            <stop offset="0.467799" stopColor="#6A45BE" />
                                            <stop offset="1" stopColor="#6A45BE" stopOpacity="0" />
                                        </radialGradient>
                                    </defs>
                                </svg>
                            </Box>
                            <Box
                                onClick={() => window.open(`${contactUSData?.facebookLink}`)}
                                sx={{ cursor: 'pointer' }}
                            >
                                <FaSquareFacebook style={{ fontSize: '30px', color: '#4460A0', borderRadius: '10px' }} />
                            </Box>
                        </Box>
                        <Button
                            variant="varient"
                            size={isSmallScreen ? 'small' : 'medium'}
                            sx={{
                                fontWeight: 400,
                                backgroundColor: '#01A0E2',
                                color: '#fff',
                                borderRadius: '10px',
                                mt: 3,
                                px: 3,
                            }}
                            onClick={handleOnEdit}>
                            Change Image & Link
                        </Button>
                    </Grid>

                    {/* Left Section - Image */}
                    <Grid item xs={12} md={6} textAlign={"center"}>
                        <Box
                            component="img"
                            src={contactUSData?.image?.url}
                            alt="Swing"
                            className="w-100 mb-3"
                        />
                    </Grid>

                </Grid>
            </Box>
        </>
    )
}

export default ContactUSPage